// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 41) return "static/chunks/41-80c47578ac08e4e4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"32":"43b273feae1da141","565":"c38360ac5562680e","685":"14bcd09561969297"}[chunkId] + ".js";
};